export default __webpack_public_path__ + "static/media/logo_white_trans.64f3446b.png";